/**
 * File modal.js.
 * Handles logic for modals
 */

function hideModal(modal, cb = () => {}) {
  modal.classList.remove('modal--show');
  modal.querySelector('.modal__focus')?.blur();
  if (cb) cb();
}

function showModal(modal, cb = () => {}) {
  modal.classList.add('modal--show');
  modal.querySelector('.modal__focus')?.focus();
  modal.addEventListener('click', function (e) {
    handleWhitespaceClick(e, cb);
  });
}

function handleWhitespaceClick(e, cb = () => {}) {
  let modal = e.target;
  if (modal.classList.contains('modal--show')) hideModal(modal, cb);
}
